const DIGITS_ONLY_PATTERN = /^\d*$/;
const NON_DIGIT_PATTERN = /\D/g;

export const isDigitsOnly = (value: string): boolean => DIGITS_ONLY_PATTERN.test(value);

export const toDigitsOnly = (value: string): string => value.replace(NON_DIGIT_PATTERN, '');
